import { Icon } from "@iconify/react";
import { Link } from "react-router";
import pallete from "./pallete";

export const breadcrumbMap = {
  "/": { title: "Dashboard", icon: "hugeicons:home-04" },
  "/profile": { title: "Profil" },
  "/training-catalog/pending": { title: "Katalog Pelatihan" },
  "/training-catalog/pending/detail/:id": {
    title: "Detail Katalog Pelatihan",
  },
  "/training-catalog/accepted": { title: "Katalog Pelatihan" },
  "/training-catalog/accepted/detail/:id": {
    title: "Detail Katalog Pelatihan",
  },
  "/training-catalog/accepted/detail/:id/participant/:id": {
    title: "Detail Peserta Pelatihan",
  },
  "/training-catalog/rejected": { title: "Katalog Pelatihan" },
  "/training-catalog/rejected/detail/:id": {
    title: "Detail Katalog Pelatihan",
  },
  "/training-verification": { title: "Verfikasi Pelatihan" },
  "/training-verification/:id": {
    title: "Detail Verfikasi Pelatihan",
  },
  "/testimony": { title: "Testimony" },
  "/testimony/create": { title: "Buat Testimony" },
  "/testimony/detail/:id": { title: "Edit Testimony" },
  "/faq": { title: "FAQ" },
  "/faq/create": { title: "Buat FAQ" },
  "/faq/detail/:id": { title: "Edit FAQ" },
  "/announcement": { title: "Pengumuman" },
  "/announcement/create": { title: "Buat Pengumuman" },
  "/announcement/detail/:id": { title: "Edit Pengumuman" },
  "/help-center": { title: "Pusat Bantuan" },
  "/vocational-institution": { title: "Lembaga Vokasi" },
  "/vocational-institution/create": { title: "Buat Lembaga Vokasi" },
  "/vocational-institution/detail/:id": { title: "Edit Lembaga Vokasi" },
  "/institutional-verification": { title: "Verifikasi Lembaga" },
  "/institutional-verification/create": { title: "Buat Verifikasi Lembaga" },
  "/institutional-verification/detail/:id": {
    title: "Edit Verifikasi Lembaga",
  },
  "/institutional-verification/migran-center": { title: "Migrant Center" },
  "/migran-center": { title: "Migrant Center" },
  "/institutional-verification/ministry-vocational-institution": {
    title: "Lembaga Vokasi Kementerian",
  },
  "/ministry-vocational-institution": {
    title: "Lembaga Vokasi Kementerian",
  },
  "/user": { title: "User" },
  "/user/create": { title: "Buat User" },
  "/user/detail/:id": { title: "Edit User" },
  "/setting/access": { title: "Pengaturan" },
  "/setting/access/create": { title: "Tambah" },
  "/setting/access/detail/:id": { title: "Edit" },
  "/master-data/institutional-identity": { title: "Master Data" },
  "/master-data/institutional-identity/create": { title: "Tambah" },
  "/master-data/institutional-identity/detail/:id": { title: "Edit" },
  "/master-data/institutional-type": { title: "Master Data" },
  "/master-data/institutional-type/create": { title: "Tambah" },
  "/master-data/institutional-type/detail/:id": { title: "Edit" },
  "/master-data/vocational-institution-ownership": { title: "Master Data" },
  "/master-data/vocational-institution-ownership/create": { title: "Tambah" },
  "/master-data/vocational-institution-ownership/detail/:id": { title: "Edit" },
  "/master-data/smk-major": { title: "Master Data" },
  "/master-data/smk-major/create": { title: "Tambah" },
  "/master-data/smk-major/detail/:id": { title: "Edit" },
  "/master-data/education-level": { title: "Master Data" },
  "/master-data/education-level/create": { title: "Tambah" },
  "/master-data/education-level/detail/:id": { title: "Edit" },
  "/master-data/program-study": { title: "Master Data" },
  "/master-data/program-study/create": { title: "Tambah" },
  "/master-data/program-study/detail/:id": { title: "Edit" },
  "/master-data/sectoral-position": { title: "Master Data" },
  "/master-data/sectoral-position/create": { title: "Tambah" },
  "/master-data/sectoral-position/detail/:id": { title: "Edit" },
  "/master-data/sector": { title: "Master Data" },
  "/master-data/sector/create": { title: "Tambah" },
  "/master-data/sector/detail/:id": { title: "Edit" },
  "/master-data/isco": { title: "Master Data" },
  "/master-data/isco/create": { title: "Tambah" },
  "/master-data/isco/detail/:id": { title: "Edit" },
  "/master-data/position": { title: "Master Data" },
  "/master-data/position/create": { title: "Tambah" },
  "/master-data/position/detail/:id": { title: "Edit" },
  "/master-data/governing-ministry": { title: "Master Data" },
  "/master-data/governing-ministry/create": { title: "Tambah" },
  "/master-data/governing-ministry/detail/:id": { title: "Edit" },
  "/master-data/institutional-affiliation": { title: "Master Data" },
  "/master-data/institutional-affiliation/create": { title: "Tambah" },
  "/master-data/institutional-affiliation/detail/:id": { title: "Edit" },
  "/history-log": { title: "Data Log" },
  "/history-log/detail/:id": { title: "Detail Data Log" },
};

const isIdLike = (segment) => {
  const isNumeric = /^\d+$/.test(segment);
  const isUUID =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(
      segment,
    );
  return isNumeric || isUUID;
};

/**
 * Extracts the path pattern from a full path by replacing actual IDs with :id placeholder
 * @param {string} path - The current path with actual IDs
 * @returns {string} - The path pattern with :id placeholders
 */
const getPathPattern = (path) => {
  // Split path by segments
  const segments = path.split("/").filter(Boolean);
  let pattern = "";

  // Identify numeric segments as IDs and replace with :id
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    // Check if segment is numeric (ID)
    if (isIdLike(segment)) {
      pattern += "/:id";
    } else {
      pattern += "/" + segment;
    }
  }

  return pattern || "/";
};

/**
 * Builds a path for breadcrumb navigation by replacing :id placeholders with actual ID values
 * @param {string} pathPattern - The path pattern with :id placeholders
 * @param {string} currentPath - The current full path with actual IDs
 * @returns {string} - The path with actual ID values
 */
const buildPathWithIds = (pathPattern, currentPath) => {
  // If no :id placeholder, return pattern as is
  if (!pathPattern.includes(":id")) {
    return pathPattern;
  }

  const patternSegments = pathPattern.split("/").filter(Boolean);
  const currentSegments = currentPath.split("/").filter(Boolean);

  // Safety check for mismatched segment lengths
  if (patternSegments.length !== currentSegments.length) {
    return pathPattern; // Return original pattern if segments don't match
  }

  let result = "";
  for (let i = 0; i < patternSegments.length; i++) {
    if (patternSegments[i] === ":id") {
      result += "/" + currentSegments[i];
    } else {
      result += "/" + patternSegments[i];
    }
  }

  return result;
};

/**
 * Generates breadcrumb items for the current location
 * @param {Object} location - The current location object
 * @returns {Array} - Array of breadcrumb items
 */
export const generateBreadcrumbItems = (location) => {
  // Get current path and prepare for breadcrumb generation
  const currentPath = location.pathname;

  // Always start with Dashboard
  const breadcrumbItems = [
    {
      key: "/",
      title: (
        <>
          <Icon
            icon="hugeicons:home-04"
            style={{ marginBottom: -3, marginRight: 5 }}
            width="16"
            height="16"
          />
          <Link to="/">Dashboard</Link>
        </>
      ),
    },
  ];

  // Get all parent paths
  const pathSegments = currentPath.split("/").filter(Boolean);

  // Find all parent paths that should appear in breadcrumb
  const parentPaths = [];
  let currentBuildPath = "";

  for (let i = 0; i < pathSegments.length; i++) {
    currentBuildPath += "/" + pathSegments[i];

    // Get the pattern for this path level
    const pattern = getPathPattern(currentBuildPath);

    // Find a matching entry in breadcrumbMap
    let matchFound = false;

    // Check if we have a direct match in breadcrumbMap
    if (breadcrumbMap[pattern]) {
      const config = breadcrumbMap[pattern];
      const actualPath = buildPathWithIds(pattern, currentBuildPath);

      parentPaths.push({
        path: actualPath,
        title: config.title,
        icon: config.icon,
        isLast: currentBuildPath === currentPath,
      });

      matchFound = true;
    }

    // If no match and this is the last segment, create a default entry
    if (!matchFound && currentBuildPath === currentPath) {
      // Try to get the parent configuration
      const parentPattern = getPathPattern(
        currentBuildPath.split("/").slice(0, -1).join("/"),
      );
      const parentConfig = breadcrumbMap[parentPattern] || {};

      parentPaths.push({
        path: currentBuildPath,
        title: `Detail ${pathSegments[i - 1] || ""}`,
        icon: "hugeicons:file-search-01",
        isLast: true,
      });
    }
  }

  // Add parent paths to breadcrumb items
  parentPaths.forEach(({ path, title, icon, isLast }) => {
    breadcrumbItems.push({
      key: path,
      title: (
        <>
          <Icon
            icon={icon}
            style={{ marginBottom: -3, marginRight: 5 }}
            width="16"
            height="16"
          />
          {isLast ? (
            <span style={{ color: pallete.primary[600] }}>{title}</span>
          ) : (
            <Link to={path}>{title}</Link>
          )}
        </>
      ),
    });
  });

  return breadcrumbItems;
};
